import { data } from "./data"
import { TypedAccessor } from "./types"
import { TableCellWidth } from "../TableCell"
import { DataColumn } from "../useTable/types"

type IntegerAccessorFn<T> = TypedAccessor<T, number | undefined>
interface IntegerColumn<T>
  extends Omit<DataColumn<T>, "type" | "renderCell" | "width"> {
  width?: TableCellWidth
}
export type IntegerColumnHelper<T> = (
  accessorFn: IntegerAccessorFn<T>,
  col: IntegerColumn<T>
) => DataColumn<T>

export function integer<T>(
  accessorFn: IntegerAccessorFn<T>,
  col: IntegerColumn<T>
): DataColumn<T> {
  return data({
    renderCell: (rowData) => {
      const value = accessorFn(rowData)
      if (!value) return "0"
      return Intl.NumberFormat("en-US").format(value)
    },
    width: TableCellWidth.Medium,
    ...col,
  })
}
